import { createApp, h } from 'vue'
import { createInertiaApp, router } from '@inertiajs/vue3'
import Echo from 'laravel-echo'
import axios from 'axios'

axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')

// Sesi kedaluwarsa → request ber-auth balas 401. Arahkan user ke /login alih-alih
// gagal diam (dropdown kosong / halaman membeku). Guard agar tidak loop di /login.
function redirectToLogin() {
    if (window.location.pathname !== '/login') {
        window.location.href = '/login'
    }
}
// Panggilan axios langsung dari komponen.
axios.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err.response?.status === 401) redirectToLogin()
        return Promise.reject(err)
    },
)
// Navigasi/visit Inertia (axios internalnya sendiri) yang balas non-Inertia (mis. 401).
router.on('invalid', (event) => {
    if (event.detail.response?.status === 401) {
        event.preventDefault()
        redirectToLogin()
    }
})

import Donut from 'vue-css-donut-chart'
import 'vue-css-donut-chart/dist/vcdonut.css'

window.Pusher = require('pusher-js')

// Key dibaca saat runtime dari meta (config server), bukan MIX_ saat build: .env tidak ikut Docker build.
// Tanpa key, Pusher melempar error dan seluruh app blank putih → realtime saja yang mati.
const pusherMeta = name => document.querySelector(`meta[name="${name}"]`)?.content
if (pusherMeta('pusher-key')) {
    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: pusherMeta('pusher-key'),
        cluster: pusherMeta('pusher-cluster'),
        forceTLS: true,
    })
}

createInertiaApp({
    progress: {
        delay: 100,
        color: '#3c4858',
        includeCSS: true,
        showSpinner: true,
    },

    resolve: (name) => require(`./Pages/${name}`),

    title: (title) => (title ? `${title}` : ``),

    setup({ el, App, props, plugin }) {
        const vueApp = createApp({
            render: () => h(App, props),
        })

        vueApp.config.globalProperties.__ = (key) => {
            return props.initialPage.props.language?.[key] ?? key
        }

        vueApp
            .mixin({ methods: { route } })
            .mixin(require('./base'))
            .use(plugin)
            .use(Donut)
            .mount(el)
    },
})

// Inertia menyimpan snapshot props di browser history. Saat user menekan tombol Back/Forward,
// ia memulihkan data LAMA dari cache (mis. list Status/Ticket tidak ter-update setelah diedit,
// harus refresh manual). Paksa ambil ulang data segar dari server pada tiap navigasi back/forward.
// Navigasi via <Link> biasa tidak terpengaruh karena memang sudah mengambil data fresh.
window.addEventListener('popstate', () => {
    // setTimeout(0) agar berjalan SETELAH Inertia selesai memulihkan halaman dari cache.
    setTimeout(() => {
        router.reload({ preserveScroll: true, preserveState: true })
    }, 0)
})
